import styled from '@emotion/styled';
import { Link, Tooltip } from '@fluentui/react-components';
import {
  Avatar,
  Divider,
  Popover,
  PopoverSurface,
  PopoverTrigger,
  SignOut20Px,
  Subscribed20Px,
  tokens,
  Typography,
} from '@galaxy-react/core';
import { AuthAgent } from '@leapdev/auth-agent';
import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserInfoContext } from 'src/app/App';
// import SearchBar from 'src/feature/SearchBar/SearchBar';

const ActionBtn = styled('div')({
  userSelect: 'none',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: 12,
  padding: '10px 16px',
  margin: '2px 5px',
  borderRadius: '4px',
  '&:hover': {
    background: tokens.colorSubtleBackground,
    padding: '10px 16px',
    margin: '2px 5px',
    borderRadius: '4px',
  },
});
const CardWrap = styled('div')({
  minWidth: '272px',
  backgroundColor: '#fff',
  borderRadius: 8,
  display: 'flex',
  flexDirection: 'column',
});

const UserInfoWrap = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  padding: 16,
  '& .userinfoContent': {
    marginLeft: '16px',
    lineHeight: '16px',
  },
});
type Props = {};

const AppBarAvatar = (props: Props) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const user = useContext(UserInfoContext);
  const firstName = user?.firstName;
  const lastName = user?.lastName;
  return (
    <Popover
      positioning={{ offset: 12, align: 'start' }}
      open={open}
      onOpenChange={(e, data) => {
        setOpen(data?.open);
      }}
    >
      <PopoverTrigger>
        <Tooltip content="Accounts & Settings" relationship="label">
          <Avatar style={{ cursor: 'pointer' }} name={`${firstName} ${lastName}`}></Avatar>
        </Tooltip>
      </PopoverTrigger>
      <PopoverSurface>
        <CardWrap>
          <UserInfoWrap>
            <Avatar name={`${firstName} ${lastName}`}></Avatar>
            <div className="userinfoContent">
              <Typography variant="bodyStrong">
                {firstName} {lastName}
              </Typography>
              <Typography variant="body">{user?.email}</Typography>
            </div>
          </UserInfoWrap>
          <Divider />
          <ActionBtn>
            <Subscribed20Px></Subscribed20Px>

            <Link
              style={{ textDecoration: 'none' }}
              onClick={() => {
                navigate('/subscription');
                setOpen(false);
              }}
              appearance="subtle"
            >
              Subscriptions
            </Link>
          </ActionBtn>
          <ActionBtn>
            <SignOut20Px></SignOut20Px>
            <Link style={{ textDecoration: 'none' }} onClick={() => AuthAgent.logout()} appearance="subtle">
              Sign out
            </Link>
          </ActionBtn>
        </CardWrap>
      </PopoverSurface>
    </Popover>
  );
};

export default AppBarAvatar;
